import _ from 'lodash'

export default {
  methods: {

    clearFormResponse() {
      return { }
    },

    addFormFieldError(formObj, fieldName, errorMsg) {      
      if(!formObj.errors)
        formObj.errors = []
      formObj.errorMessage = 'Errors were found in the following fields'
      formObj.errors.push({ field: fieldName, message: errorMsg })
      
      return formObj
    },

    formResponseHasErrors(formObj) {
      return formObj.errors && formObj.errors.length > 0
    },

    processFormResponse(error) {
      var formObj = {}
      try {
        if(typeof error === 'string') {
          formObj.errorMessage = error
        }

        if(typeof error === 'object') {
          let response = error.response
          if(response && response.data && response.data.error && response.data.error.code == 'BadFieldError') {
            formObj.errors = []

            if(response.data.error.details) {
              formObj.errors = response.data.error.details.map(errDetail => {
                return {
                  field: errDetail.target,
                  message: errDetail.message
                }
              })
            }
          }

          formObj.errorMessage = _.get(response, 'data.error.message')
          formObj.errorData = _.get(response, 'data.error.data', {})

          if(formObj.errorMessage == null) {
            console.error(error)
            formObj.errorMessage = `Unknown error ${response ? response.status : ''} received from server. Please try again or contact the administrator if this continues`
          }
        }

        return formObj
      } catch(err) {
        formObj = {
          errorMessage: 'Error processing response from server. Please try again or contact the administrator if this continues'
        }
        return formObj
      }
    },

    getLookupName(lookupList, value) {
      if(lookupList == null)
        return ''
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0].name
      return ''
    },

    getLookupInfo(lookupList, value, fieldName) {
      if(lookupList == null)
        return ''
        
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0][fieldName]
      return ''
    },

    // Convert a standard database object list into an array of ID numbers
    // Assumes the primary key is 'id'
    // Used for form selection / multi-select type components
    convertListToIDs(list) {
      if(!list)
        return []
      return list.map(listItem => listItem.id)
    }
  }
}
